export enum ExportStatus {
  Pending = 'pending',
  Processing = 'processing',
  Finished = 'finished',
  Failed = 'failed',
}

export interface ExportJob {
  id: number;
  type: string;
  name: string;
  status: ExportStatus;
  filters?: Record<string, unknown>;
  error_message?: string | null;
  finished_at?: string | null;
  created_at?: string | null;
}
